// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","subtitle":"SubTitle_subtitle__3XHqQ sharedStyles_standardTextStructure__2HVr-"};